import { map, clamp } from "../utils/utils.js";
import KeenSlider from "keen-slider";

class WorldMap {
  constructor(el) {
    if (!el) return;
    this.scroll = window.scrollY;
    this.mapItems = el.querySelectorAll("[data-map]");
    this.mapWorldItems = this.mapItemsToObj(el);
    this.mapWorldItemsStartEnd = [0, 100];
    this.totalImageBounds = {};

    this.mapWorldBounds();
    window.addEventListener("resize", this.mapWorldBounds.bind(this));
    this.mapWorldScrolling();
    window.addEventListener("scroll", this.mapWorldScrolling.bind(this));
  }

  mapItemsToObj(elItem) {
    let mapItemsObj = {};
    const mapItemsArray = elItem.querySelectorAll("[data-map]");
    for (let i = 0; i < mapItemsArray.length; i++) {
      mapItemsObj[mapItemsArray[i].dataset.map] = mapItemsArray[i];
    }

    return mapItemsObj;
  }

  mapWorldBounds() {
    this.scroll = window.scrollY;
    const trackerBounds =
      this.mapWorldItems["tracker"]?.getBoundingClientRect() || false;
    if (!trackerBounds)
      return {
        top: [0, 100],
        left: [0, 100],
        width: [0, 100],
        height: [0, 100],
      };

    this.mapWorldItemsStartEnd = [
      trackerBounds.top + this.scroll,
      trackerBounds.top + this.scroll + window.innerHeight / 2,
    ];

    const maskBounds = this.mapWorldItems["mask"].getBoundingClientRect();

    this.totalImageBounds = {
      top: [0, maskBounds.top - trackerBounds.top],
      left: [0, maskBounds.left],
      width: [window.innerWidth, maskBounds.width],
      height: [window.innerHeight, maskBounds.height],
    };
  }

  mapWorldScrolling() {
    this.scroll = window.scrollY;

    const mapWorldPerc = clamp(
      map(this.mapWorldItemsStartEnd, [0, 100], this.scroll),
      0,
      100
    );

    this.mapWorldItems["text"].style.opacity = `${map(
      [0, 100],
      [1, 0],
      mapWorldPerc
    )}`;

    this.mapWorldItems["image"].style.width = `${map(
      [0, 100],
      this.totalImageBounds["width"],
      mapWorldPerc
    )}px`;

    this.mapWorldItems["image"].style.height = `${map(
      [0, 100],
      this.totalImageBounds["height"],
      mapWorldPerc
    )}px`;
    this.mapWorldItems["image"].style.transform = `translate(${map(
      [0, 100],
      this.totalImageBounds["left"],
      mapWorldPerc
    )}px, ${map([0, 100], this.totalImageBounds["top"], mapWorldPerc)}px)`;
    this.mapWorldItems["image"].style.borderRadius = `${map(
      [0, 100],
      [0, 1],
      mapWorldPerc
    )}rem`;
  }
}

export default WorldMap;
